import {
    Box,
    Breadcrumbs,
    Button,
    Card,
    CardActions,
    CardContent,
    Container,
    Divider,
    Grid,
    Input,
    InputAdornment,
    InputBase,
    Link,
    MenuItem,
    OutlinedInput,
    Pagination,
    Paper,
    Select,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import PeopleIcon from "@mui/icons-material/People";
import GroupsIcon from "@mui/icons-material/Groups";
import WorkIcon from "@mui/icons-material/Work";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Person, TextFieldsOutlined } from "@mui/icons-material";
import { Link as RouterLink, useNavigate } from "react-router-dom";

function OverviewDashboard() {
    const navigate = useNavigate();
    const handleClickCreateNewGroup = () => navigate("/admin/groups/new");

    // fetch api

    // store

    return (
        <>
            {/** Breadcrumbs */}
            <Container sx={{ marginY: 2 }}>
                <Breadcrumbs sx={{ my: 1 }}>
                    <div>Admin</div>
                    <div>Overview</div>
                </Breadcrumbs>
                <Divider />
            </Container>

            {/** Header */}
            <Container sx={{ marginY: 3 }}>
                <Typography variant="h1" fontSize={34} fontWeight="bold">
                    Overview
                </Typography>
            </Container>

            {/** Content */}
            <Container sx={{ marginY: 3 }}>
                <Grid container direction="row" justifyContent="flex-start" alignItems="stretch" spacing={3}>
                    <Grid item xs="auto" sm={4}>
                        <Card>
                            <CardContent sx={{ display: "flex" }}>
                                <Box sx={{ flexGrow: 1, margin: 2 }}>
                                    <Box sx={{ display: "inline-flex" }}>
                                        <Person sx={{ marginRight: 2 }} />
                                        <strong>-</strong>
                                    </Box>
                                    <Box>Users</Box>
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Button variant="outlined">New User</Button>
                                </Box>
                            </CardContent>

                            <Divider />

                            <CardActions sx={{ margin: 1 }}>
                                <Link
                                    component={RouterLink}
                                    underline="hover"
                                    to="/admin/users"
                                    sx={{ display: "inline-flex" }}
                                >
                                    View user list <NavigateNextIcon />
                                </Link>
                            </CardActions>
                        </Card>
                    </Grid>

                    <Grid item xs="auto" sm={4}>
                        <Card>
                            <CardContent sx={{ display: "flex" }}>
                                <Box sx={{ flexGrow: 1, margin: 2 }}>
                                    <Box sx={{ display: "inline-flex" }}>
                                        <GroupsIcon sx={{ marginRight: 2 }} />
                                        <strong>-</strong>
                                    </Box>
                                    <Box>Groups</Box>
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Button variant="outlined" onClick={handleClickCreateNewGroup}>
                                        New Groups
                                    </Button>
                                </Box>
                            </CardContent>

                            <Divider />

                            <CardActions sx={{ margin: 1 }}>
                                <Link
                                    component={RouterLink}
                                    underline="hover"
                                    to="/admin/groups?groupType=organization"
                                    sx={{ display: "inline-flex" }}
                                >
                                    View group list <NavigateNextIcon />
                                </Link>
                            </CardActions>
                        </Card>
                    </Grid>

                    <Grid item xs="auto" sm={4}>
                        <Card>
                            <CardContent sx={{ display: "flex" }}>
                                <Box sx={{ flexGrow: 1, margin: 2 }}>
                                    <Box sx={{ display: "inline-flex" }}>
                                        <WorkIcon sx={{ marginRight: 2 }} />
                                        <strong>-</strong>
                                    </Box>
                                    <Box>Teams</Box>
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    <Button variant="outlined">New Team</Button>
                                </Box>
                            </CardContent>

                            <Divider />

                            <CardActions sx={{ margin: 1 }}>
                                <Link
                                    component={RouterLink}
                                    underline="hover"
                                    to="/admin/groups?groupType=team"
                                    sx={{ display: "inline-flex" }}
                                >
                                    View team list <NavigateNextIcon />
                                </Link>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export default OverviewDashboard;
